import { useMutation, useQueryClient } from "react-query";

import { crearRecolector, updateRecolector, deleteRecolector} from '../../services/Recolectores';

import { toast } from 'react-hot-toast';
const queryKey = "recolectores";

export const useRecolectoresMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addRecolector = useMutation((body) => crearRecolector(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
  const updateRecolectorD = useMutation(
    (body) => updateRecolector( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeRecolector = useMutation((id) => deleteRecolector( id), {
    onSuccess,
    onError,
  });

  return { addRecolector, updateRecolectorD, removeRecolector };
};
export default useRecolectoresMutations;